const groupPrefix = createApiRoute(ApiModule.SYSTEM, ApiDataModel.SCHEDULE)
const groupPrefixBlacklist = createApiRoute(ApiModule.SYSTEM, ApiDataModel.SCHEDULE_BLACKLIST)

export const apiOrderSchedule = {
	fetchOrderScheduleOperations: async (): Promise<IOrderScheduleOperationModel[]> => {
		const { data } = await apiCommon<IOrderScheduleOperation[]>(`${groupPrefix}`, { method: 'GET' })

		return data.map(d => OrderScheduleOperation(d))
	},

	updateOrderScheduleOperations: async (
		selectedDay: EOrderScheduleDays,
		payload: IOrderScheduleDeadlineModel,
	): Promise<IOrderScheduleOperationModel[]> => {
		const { data } = await apiCommon<IOrderScheduleOperation[]>(`${groupPrefix}/${selectedDay}`, {
			method: 'PATCH',
			body: OrderScheduleOperationPayloadToBody(payload),
		})

		return data.map(d => OrderScheduleOperation(d))
	},

	fetchOrderScheduleLimitations: async (): Promise<IOrderScheduleLimitationListModel> => {
		const { data } = await apiCommon<IOrderScheduleLimitationList>(`${groupPrefixBlacklist}`, { method: 'GET' })

		return OrderScheduleBlacklistList(data)
	},

	createOrderScheduleLimitation: async (
		payload: IOrderScheduleLimitationCreate,
	): Promise<IOrderScheduleLimitationModel> => {
		const { data } = await apiCommon<IOrderScheduleLimitation>(`${groupPrefixBlacklist}`, {
			method: 'POST',
			body: OrderScheduleLimitationToJson(payload),
		})

		return OrderScheduleBlacklistItem(data)
	},
}
